import findDataObject from "../../../../objects/CommonUse/find_data_object";

export const buildHistoryTransactionObj = (basicTranInfo) => {
    let transactionObj = JSON.parse(JSON.stringify(findDataObject("investHistoryTransaction").investTranObj));
    transactionObj.investShortName = basicTranInfo.investShortName;
    transactionObj.investmentName = basicTranInfo.investmentName;
    transactionObj.tranType = basicTranInfo.tranType;
    transactionObj.quantity = basicTranInfo.quantity.toString();
    transactionObj.dateClosed = basicTranInfo.dateClosed;
    transactionObj.sellPrice = basicTranInfo.sellPrice.toString();
    let newSellAmount = +basicTranInfo.sellAmount;
    newSellAmount = newSellAmount.toFixed(2);
    transactionObj.sellAmount = newSellAmount.toString();
    let newTotalGainLoss = +basicTranInfo.totalGainLoss;
    newTotalGainLoss = newTotalGainLoss.toFixed(2);
    transactionObj.totalGainLoss = newTotalGainLoss.toString();
    transactionObj.transNbr = basicTranInfo.transNbr;
    if (basicTranInfo.tranType === "redemption" || basicTranInfo.tranType === "buy-sell"){
        transactionObj.dateBought = basicTranInfo.dateBought;
        transactionObj.buyPrice = basicTranInfo.buyPrice;
        let newBuyAmount = +basicTranInfo.buyAmount;
        newBuyAmount = newBuyAmount.toFixed(2);
        transactionObj.buyAmount = newBuyAmount.toString();
    }else{
        transactionObj.dateBought = basicTranInfo.dateClosed;
        transactionObj.buyPrice = "0";
        transactionObj.buyAmount = "0";
    }
   
    return transactionObj;
}


export default buildHistoryTransactionObj;